type ValidContent =
    | null
    | string
    | number
    | boolean
    | Array<JSON>
    | Date
    | undefined
    | {
          [prop: string]: ValidContent;
      };

//eslint-disable-next-line @typescript-eslint/no-explicit-any
type ZipReturn<T extends any[][]> = T[0] extends infer A
    ? {
          [K in keyof A]: [
              ...{
                  [K2 in keyof T]: K extends keyof T[K2] ? T[K2][K] : undefined;
              },
          ];
      }
    : never;

function range(size: number, startAt = 0): ReadonlyArray<number> {
    //@ts-ignore
    return [...Array(size).keys()].map(i => i + startAt);
}

export default function zip<T extends [...{ [K in keyof S]: S[K] }][], S extends ValidContent[]>(...arrays: [...T]): ZipReturn<T> {
    const maxLength = Math.max(...arrays.map(x => x.length));

    return range(maxLength).map((_, i) => {
        return range(arrays.length).map((_, k) => arrays[k][i]);
    }) as unknown as ZipReturn<T>;
}
